.comments {
  width: 100%;
  display: block;
  font-size: 14px;
}
.comments .inputTitle, .comments .inputPost {
  width: 100%;
  display: block;
  margin-bottom: 8px;
}
.comments .buttonRighter {
  width: 100%;
  text-align: right;
}
.comments .postLayout {
  display: flex;
  flex-flow: row nowrap;
}
.comments .postLayout .postVoting {
  flex: 0 auto;
}
.comments .postLayout .postVoting .votesLayout {
  display: flex;
  flex-flow: column nowrap;
}
.comments .postLayout .postVoting .votesLayout .upvote {
  font-weight: bold;
}
.comments .postLayout .postVoting .votesLayout .points {
  text-align: center;
}
.comments .postLayout .postVoting .votesLayout .downvote {
  font-weight: bold;
}
.comments .postLayout .postContent {
  flex: 1 auto;
}
.comments .postLayout .postContent .postInfo {
  width: 100%;
  background-color: #a0a0a0;
  padding: 8px;
  display: flex;
  flex-flow: row nowrap;
  border-radius: 4px;
}
.comments .postLayout .postContent .postInfo .infoUser {
  flex: 0 auto;
  padding: 8px;
}
.comments .postLayout .postContent .postInfo .dates {
  flex: 0 auto;
  display: flex;
  flex-flow: column nowrap;
}
.comments .postLayout .postContent .postInfo .dates .date {
  flex: 0 auto;
  font-size: 10px;
  color: #505050;
}
.comments .postLayout .postContent .postInfo .buttons {
  margin-left: auto;
  height: 100%;
}
.comments .postLayout .postContent .postInfo .buttons .buttonSep {
  margin-left: 4px;
}
.comments .postLayout .postContent .post {
  padding: 8px;
}
.comments .postReply {
  flex: 0 auto;
}

.noComments {
  width: 100%;
  text-align: center;
  height: 48px;
  line-height: 32px;
  font-size: 12px;
  font-style: italic;
  padding: 8px;
  border: 2px dotted #a0a0a0;
  border-radius: 4px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */